<template>
   <div v-if="loading" class="loading-container">
    <img src="../../assets/fonts/loadingNine.gif" alt="loading">
  </div>
  <div v-else class="quickLogin-container">
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '',
      loading: true // 控制加载状态
    }
  },
  created() {
    // localStorage.clear() //跳转登录进来后清除所有缓存
    const { ticket } = this.$route.query
    let str = encodeURIComponent(ticket)
    if (str) {
      this.axios
        .get(`/thirdLogin/stu/login?eduCode=`+102+'&ticket='+str)
        .then((res) => {
          if (res.code === 200) {
            // let userInfo = res.result.userInfo
            // userInfo.eduHomeUrl = res.result.eduHomeUrl || null
            // userInfo.eduLogo = res.result.eduLogo || null
            // localStorage.removeItem('WEAK_PASSWORD')
            // 登陆成功拿homeObj
            // this.axios.get(`/biz/home/param`).then(res => {
            //   if (res.code === 200) {
            //     this.$store.state.homeObj = res.result
            //     localStorage.setItem('homeObj', JSON.stringify(res.result))
            //     console.log(this.$store.state.homeObj, 'Vuex')
            //   }
            // })
            location.href = res.result
          } else {
            this.loading = false
            this.title = `此次登录失败，请关闭页面后请重试`
          }
        })
        .catch(() => {
          // this.title = `此次登录失败，请关闭页面后请重试`
        })
    }
  }
}
</script>

<style lang="scss" scoped>

.quickLogin-container {
  text-align: center;
  padding: 100px;
  font-size: 30px;
}


.loading-container {
  background-color:#fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* 或者其他适合的高度 */
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginIndex/hnlgLogin.vue